interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
}

const SIZES = { sm: 14, md: 22, lg: 36 };

export function Spinner({ size = 'md' }: SpinnerProps) {
  const px = SIZES[size];
  return (
    <div
      style={{
        width: px, height: px,
        border: `${size === 'sm' ? 2 : 3}px solid rgba(99,102,241,0.2)`,
        borderTopColor: '#6366f1',
        borderRadius: '50%',
        animation: 'spin 0.75s linear infinite',
        display: 'inline-block',
      }}
    >
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
